import { cloneElement, Fragment } from "react";
import { Link } from "react-router-dom";

interface IParams {
    children: JSX.Element;
    link: string;
}

export const DynamicLink = ({ link, children }: IParams) => {
    const appLink = process.env.MYACCOUNT_URL ?? "https://my.gomo.ie/";
    const isAppLink = link.includes(appLink);

    return (
        <Fragment>
            {isAppLink && <Link to={link.replace(appLink, "")}>{children}</Link>}
            {!isAppLink && cloneElement(children, { href: link })}
        </Fragment>
    );
};
